<template>
  <section class="padding"> 
     
      <div class="footer">
           <div class="flex">
<div class="container1">
<h1>Get in Touch</h1>
<img src="../../assets/underline3.png" alt="">
<h4>Li’lyogisbysabrina@gmail.com <br> +91 99999 99999</h4>
<div class="icons font-icon">
<!-- <img class="socialIcon" src="../../assets/Socialicon1.png" alt="">
<img class="socialIcon" src="../../assets/Socialicon2.png" alt="">
<img class="socialIcon" src="../../assets/Socialicon3.png" alt="">
<img class="socialIcon"  src="../../assets/Socialicon4.png" alt=""> -->
<a href="https://www.instagram.com/lilyogis_sabz/" target="_blank" ><font-awesome-icon class="bg socialIcon" :icon="['fab', 'instagram']"/></a>
<a href="" target="_blank"><font-awesome-icon class="bg socialIcon" :icon="['fab', 'dribbble']"/></a>
<a href=""><font-awesome-icon class="bg socialIcon" :icon="['fab', 'twitter']"/></a>
<a href="https://www.youtube.com/channel/UCTFHM_8zoIUZVIvVG4dTdzw" target="_blank"><font-awesome-icon class="bg socialIcon" :icon="['fab', 'youtube']"/></a>

<!-- <i class="fab fa-instagram"></i> -->
</div>
</div>

<div class="container2">
    <h2>Join our Community</h2>
    <div class="icon">
    <input type="text" placeholder="Your email address" required>
    <img class="vector" src="../../assets/Vector.png" alt="">
    </div>
    <div>
    <img src="../../assets/footer_logo.png" alt="">
    </div>
</div>

<div class="container3">
    <h2 class="padding1">Quick Links</h2>
    <ul>
        <li> <router-link  :to="{name: 'Home'}">Home</router-link></li>
        <li >  <router-link :to="{name: 'ourPrograms'}">Our Programs</router-link> </li>
        <li> <router-link :to="{name: 'BecomeATeacher'}">Become a Teacher</router-link> </li>
        <li> <router-link :to="{name: 'AboutUs'}">About Us / Our Story</router-link> </li>
        <li> <router-link :to="{name: 'Shop'}">Shop</router-link> </li>
        <li> <router-link :to="{name: 'Blogs'}">Blogs</router-link> </li>
    </ul>
    <!-- <h2>Quick Links</h2>
    <h4 class="child">Home</h4>
    <h4 class="child">Our Programs</h4>
    <h4 class="child">Become a teacher</h4>
    <h4 class="child">ABout us / Our story</h4>
    <h4 class="child">Shop</h4>
    <h4 class="child">Blogs</h4> -->
</div>

</div>
      </div>
  </section>
</template>

<script>


export default {

}
</script>

<style scoped>


.bg{
    color: white;
    background-color: #86339E;
    height: 40px;
    width: 40px;
    display: inline-block;
    padding: 10px;
    border-radius: 50%;
}

/* .icons{
height: 40px;
    width: 40px;
} */

.vector{
            position: relative;
    top: 5px;
    left: 12px;
    cursor: pointer;
}

::placeholder {
  color: #D9DBE1;
  padding: 10px;
}
/* .icon{
background-image: url(../../assets/Vector.png) ;
    background-repeat: no-repeat;
    background-position: right;
   
    padding-right: 0px;
    cursor: pointer;
} */

.socialIcon{
    transform: scale(1);
    transition: all 0.2s ease;
    cursor: pointer;
}
.socialIcon:hover{
    transform: scale(1.5);
    color: #86339E;
    background-color: white;
}
.icon{
    height: 35px;
    width: 269px;
    background-color: rgba(255, 255, 255, .15);
    border-radius: 10px;
}
input{
     background-color: rgba(255, 255, 255, 0);
    outline: none;
    border: none;
    height: 35px;
    width: 223px;
    border-radius: 10px;
    color: white;
    padding: 10px;
}
.padding1{
    padding-right: 20px;
}
li{
    text-decoration: none;
    list-style: none;
    line-height: 200%;
}
a{
    color: #D9DBE1;
    text-decoration: none;
    transition: all 0.2s ease;
}
.container3 li a:hover{
    padding-left: 10px;
    color: white;
}
.padding{
    margin-top: 150px;
}
.icons{
        display: flex;
    justify-content: space-between;
    width: 227px;
}

.container1{
        display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 372px;
    height: 278px;
     margin-bottom: 50px;

    
}
.container2{
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    height: 297px;
    align-items: center;
    width: 372px;
     margin-bottom: 50px;

}
.container3{
        display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 245px;
    width: 372px;
     margin-bottom: 50px;
/* align-items: center; */
padding-left: 56px;
}

.child{
    color:  #D9DBE1;
}

.footer{
    min-width: 100%;
min-height: 50%;
background: #791E94;

}
.flex{
display: flex;
    width: 80%;
    margin: auto;
    align-items: center;
    justify-content: space-between;
    padding-top: 36px;
    flex-wrap: wrap;
   
}
h1{
     font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: white;
}
h4{
    color: white;
    font-weight: 500;
    line-height: 200%;
}
h2{
    font-weight: 600;
    color: white;
}

@media (max-width: 1000px){
    .container1, .container2, .container3{
        width: 70%;

    }
    .container2{
        text-align: center;
    }
    .flex{
        justify-content: center;
    }
    .container3{
        align-items: center;
        padding-left: 0px;
}
    }
    @media (max-width: 1000px){
        .container1{
        width: 372px;

    }
    }

</style>